import { wrappedPost } from "../../general/utils.js";

let FABRIC_CANVAS;
let FILE_TYPE;

let base64Gif = "";

export const setBase64Gif = (content) => {
  base64Gif = content;
};

const resizeCustomImage = (width, height) => {
  $("#widthOutput").text(width);
  $("#heightOutput").text(height);
  $("#customImageCanvas").width(width);
  $(".fabricContainer").width(width);
  $("#customImageCanvas").height(height);
  $(".fabricContainer").height(height);
  FABRIC_CANVAS.setWidth(width);
  FABRIC_CANVAS.setHeight(height);
  FABRIC_CANVAS.calcOffset();
};

const initializeCanvas = () => {
  FABRIC_CANVAS = new fabric.Canvas("customImageCanvas");
  FABRIC_CANVAS.selection = false;

  fabric.Object.prototype.hasBorders = false;
  fabric.Object.prototype.cornerSize = 8;

  fabric.Object.prototype.setControlsVisibility({
    tl: false,
    tr: false,
    bl: false,
    br: false,
    mt: false,
    mb: false,
  });

  const FONTS = [
    "Amatic SC",
    "Architects Daughter",
    "Bad Script",
    "Bebas Neue",
    "Ceviche One",
    "Chewy",
    "Fredericka the Great",
    "Fredoka",
    "Grenze",
    "Henny Penny",
    "Indie Flower",
    "Luckiest Guy",
    "Mulish",
    "Noto Sans",
    "Permanent Marker",
    "Ranchers",
    "Righteous",
    "Roboto",
    "Shadows Into Light Two",
    "Special Elite",
    "Staatliches",
  ];

  const fontSelect = $("#fontSelect");
  FONTS.forEach((font) => {
    fontSelect.append(
      $("<option>", {
        value: font,
        "data-content": `<span style='font-family: "${font}"'>${font}</span>`,
      }),
    );
  });

  fontSelect.selectpicker("refresh");
  fontSelect.selectpicker("val", "Permanent Marker");

  fontSelect.on("change", (e) => {
    const font = e.target.value;
    const observer = new FontFaceObserver(font);
    observer
      .load()
      .then(() => {
        FABRIC_CANVAS.getActiveObject().set("fontFamily", font);
        FABRIC_CANVAS.requestRenderAll();
      })
      .catch(() => {
        console.error(`font load failed: ${font}`);
      });
  });

  $("#textButton").click(() => {
    const object = new fabric.Textbox("Text", {
      fontSize: 48,
      fontFamily: fontSelect.selectpicker("val"),
      fill: "#858796",
      left: 100,
      top: 100,
    });
    FABRIC_CANVAS.add(object).setActiveObject(object);
    FABRIC_CANVAS.renderAll();
  });

  const changeFontSize = (e, elementId) => {
    const fontValue = e.target.value > 365 ? 365 : e.target.value;
    $(`#${elementId}`).val(fontValue);
    const object = FABRIC_CANVAS.getActiveObject();
    if (object.type === "textbox") {
      object.fontSize = fontValue;
      FABRIC_CANVAS.requestRenderAll();
    }
  };

  $("#fontSizeNumberInput").on("keyup", (e) =>
    changeFontSize(e, "fontSizeInputSlider"),
  );
  $("#fontSizeInputSlider").on("input", (e) =>
    changeFontSize(e, "fontSizeNumberInput"),
  );

  $("#widthInput").on("input", (e) => {
    resizeCustomImage(e.target.value, $("#heightInput").val());
  });

  $("#heightInput").on("input", (e) => {
    resizeCustomImage($("#widthInput").val(), e.target.value);
  });

  resizeCustomImage(640, 640);

  $("#xSkewInput").on("input", (e) => {
    FABRIC_CANVAS.getActiveObject()
      .set("skewX", parseInt(-e.target.value, 10))
      .setCoords();
    FABRIC_CANVAS.requestRenderAll();
  });

  $("#ySkewInput").on("input", (e) => {
    FABRIC_CANVAS.getActiveObject()
      .set("skewY", parseInt(e.target.value, 10))
      .setCoords();
    FABRIC_CANVAS.requestRenderAll();
  });

  $("#xSkewInput").on("dblclick", () => {
    $("#xSkewInput").val(0);
    FABRIC_CANVAS.getActiveObject().set("skewX", 0).setCoords();
    FABRIC_CANVAS.requestRenderAll();
  });

  $("#ySkewInput").on("dblclick", () => {
    $("#ySkewInput").val(0);
    FABRIC_CANVAS.getActiveObject().set("skewY", 0).setCoords();
    FABRIC_CANVAS.requestRenderAll();
  });

  $("#opacityInput").on("input", (e) => {
    FABRIC_CANVAS.getActiveObject().set("opacity", e.target.value / 100);
    FABRIC_CANVAS.requestRenderAll();
  });

  const addDeleteBtn = (e) => {
    const btnGroup = $("#btnGroup");
    btnGroup.addClass("canvas-btns");
    const { x } = e.target.oCoords.mb;
    const { y } = e.target.oCoords.mb;
    $("#btnGroup").appendTo(".canvas-container");
    $("#btnGroup")
      .css({ top: `${y + 30}px`, left: `${x - btnGroup.width() / 2}px` })
      .show();
  };

  const removeDeleteBtn = () => {
    $("#btnGroup").hide();
  };

  FABRIC_CANVAS.on({
    "selection:created": addDeleteBtn,
    "selection:updated": addDeleteBtn,
    "object:modified": addDeleteBtn,
  });

  FABRIC_CANVAS.on("mouse:down", () => {
    if (!FABRIC_CANVAS.getActiveObject()) {
      $("#btnGroup").hide();
    }
  });

  FABRIC_CANVAS.on({
    "object:scaling": removeDeleteBtn,
    "object:moving": removeDeleteBtn,
    "object:rotating": removeDeleteBtn,
  });

  $("#deleteBtn").on("click", () => {
    if (FABRIC_CANVAS.getActiveObject()) {
      FABRIC_CANVAS.remove(FABRIC_CANVAS.getActiveObject());
      $("#btnGroup").hide();
    }
  });

  const displayPanel = () => {
    const object = FABRIC_CANVAS.getActiveObject();

    if (object.type === "textbox") {
      $("#xSkewInput").val(-object.skewX);
      $("#ySkewInput").val(object.skewY);
      $("#colorInput").val(object.fill);
      $("#opacityInput").val(object.opacity * 100);
      $("#fontSelect").selectpicker("val", object.fontFamily);
      $("#fontSizeInputSlider").val(object.fontSize);
      $("#fontSizeNumberInput").val(object.fontSize);
    }
    $("#fontDiv").toggle(object.type === "textbox");
  };

  FABRIC_CANVAS.on({
    "selection:created": displayPanel,
    "selection:updated": displayPanel,
  });

  FABRIC_CANVAS.on("selection:cleared", () => {
    $("#fontDiv").hide();
  });

  $("#colorInputBtn").on("click", () => {
    $("#colorInput").click();
  });

  $("#colorInput").on("input", (e) => {
    if (!FABRIC_CANVAS.getActiveObject()) return;
    FABRIC_CANVAS.getActiveObject().set("fill", e.target.value);
    FABRIC_CANVAS.requestRenderAll();
  });

  const VARIABLES = {
    "First Name": "{{firstName}}",
    "Last Name": "{{lastName}}",
    "Role / Job Title": "{{role}}",
    Company: "{{company}}",
  };

  Object.entries(VARIABLES).forEach(([key, val]) => {
    $("#variableDropdownMenu").append(
      `<a class="dropdown-item custom-image-dropdown-item" data-value="${val}">${key}</a>`,
    );
  });

  $(".custom-image-dropdown-item").on("click", (e) => {
    const object = FABRIC_CANVAS.getActiveObject();
    if (object.type === "textbox") {
      const chars = $(e.target).attr("data-value");
      const start = object.selectionStart;
      const end = object.selectionEnd;

      object.enterEditing();
      object.insertChars(chars, null, start, end);
      object.selectionStart = start + chars.length;
      object.selectionEnd = start + chars.length + 1;
      object.exitEditing();
      FABRIC_CANVAS.renderAll();
      object.enterEditing();
    }
  });

  $("#copyBtn").on("click", () => {
    FABRIC_CANVAS.getActiveObject().clone((cloned) => {
      FABRIC_CANVAS.discardActiveObject();
      cloned.set({
        left: cloned.left + 20,
        top: cloned.top + 20,
        evented: true,
      });
      FABRIC_CANVAS.add(cloned);
      FABRIC_CANVAS.setActiveObject(cloned);
      FABRIC_CANVAS.requestRenderAll();
    });
  });

  ["left", "right", "center", "justify"].forEach((alignment) => {
    $(`#${alignment}AlignBtn`).on("click", () => {
      const object = FABRIC_CANVAS.getActiveObject();
      if (object.type === "textbox") {
        object.textAlign = alignment;
        FABRIC_CANVAS.requestRenderAll();
      }
    });
  });

  $("#insertCustomImageBtn").on("click", () => {
    let postData;
    const height = FABRIC_CANVAS.getHeight();
    const width = FABRIC_CANVAS.getWidth();
    const tinyMceEditor = tinymce.activeEditor.getDoc();

    const checkImage = () => {
      const interval = setInterval(() => {
        const images = $(tinyMceEditor).find(".sw-custom-image");
        const loader = $(tinyMceEditor).find(".loader");
        for (let i = 0; i < images.length; i += 1) {
          if (!images[i].complete) {
            $(loader).css("display", "flex");
            tinymce.activeEditor.mode.set("readonly");
            return;
          }
        }
        for (let x = 0; x < images.length; x += 1)
          $(images[x]).css("display", "block").removeAttr("data-mce-style");
        $(loader).remove();
        clearInterval(interval);
        tinymce.activeEditor.mode.set("design");
      }, 500);
    };

    if (FILE_TYPE === "gif") {
      const imageObject = `
          "backgroundImage":{
            "fileType":"gif",
            "type":"image",
            "version":"4.2.0",
            "originX":"left",
            "originY":"top",
            "left":0,
            "top":0,
            "width":${width},
            "height":${height},
            "fill":"rgb(0,0,0)",
            "stroke":null,
            "strokeWidth":0,
            "strokeDashArray":null,
            "strokeLineCap":"butt",
            "strokeDashOffset":0,
            "strokeLineJoin":"miter",
            "strokeMiterLimit":4,
            "scaleX":1,
            "scaleY":1,
            "angle":0,
            "flipX":false,
            "flipY":false,
            "opacity":1,
            "shadow":null,
            "visible":true,
            "backgroundColor":"white",
            "fillRule":"nonzero",
            "paintFirst":"fill",
            "globalCompositeOperation":"source-over",
            "skewX":0,
            "skewY":0,
            "cropX":0,
            "cropY":0,
            "src":"${base64Gif}",
            "crossOrigin":null,
            "filters":[]
            },`;

      postData = {
        content:
          JSON.stringify(FABRIC_CANVAS).substring(0, 1) +
          imageObject +
          JSON.stringify(FABRIC_CANVAS).substring(1),
      };
    }
    if (FILE_TYPE === "image")
      postData = { content: JSON.stringify(FABRIC_CANVAS) };

    wrappedPost(
      {
        url: "/api/campaigns/save_custom_image",
        data: JSON.stringify(postData),
        success: (res) => {
          const html = `<img style="${
            FILE_TYPE === "gif" ? "display:none" : ""
          }" class="sw-custom-image ${
            FILE_TYPE === "gif" ? "sw-custom-image-gif" : ""
          }" width="${width > 600 ? 600 : width}" src="${res.url}"/>`;
          const loader = `<div class="loader" style="background: #000000; color: white; width: ${
            width < 350 ? 350 : width
          }px; height: ${
            height < 300 ? 300 : height
          }px; padding: 0; display: none; align-items: center; justify-content: center; "><div style=" text-align: center;bottom: 25%;
          position: relative;"><p style="margin: 0;font-size: 20px;">Loading...</p><p style="margin: 0;font-size: 14px;">Processing image, this can take up to 10 seconds</p></div></div>`;
          tinymce.activeEditor.execCommand("mceInsertContent", false, html);
          $("#customImageModal").modal("hide");
          $("#insertCustomImageBtn").attr("disabled", false);
          checkImage();
          tinymce.activeEditor.execCommand("mceInsertContent", false, loader);
        },
        spinner: "#insertCustomImageBtn",
      },
      false,
    );
  });

  $("#customImageModal").on("hidden.bs.modal", () => {
    FABRIC_CANVAS.clear();
    $("#btnGroup").hide();
    $("#gifCanvas").remove();
    $("#gifHtmlInCanvas").remove();
  });
};

export const loadImageToCanvas = (options) => {
  if (!FABRIC_CANVAS) initializeCanvas();

  const { file, image, existingImage } = options;
  image.onload = () => {
    $("#insertCustomImageBtn").text("Insert Image");
    $("#customImageContainer").removeAttr("style").removeClass("bigger-btns");
    FABRIC_CANVAS.setViewportTransform([1, 0, 0, 1, 0, 0]);
    FABRIC_CANVAS.requestRenderAll();
    const MAX_SIZE = 600;
    let { width, height } = image;
    if (width > height) {
      if (width > MAX_SIZE) {
        height *= MAX_SIZE / width;
        width = MAX_SIZE;
      }
    } else if (height > MAX_SIZE) {
      width *= MAX_SIZE / height;
      height = MAX_SIZE;
    }

    if ((file && file.type === "image/gif") || file === "gif") {
      $(".canvas-container").removeClass("image-center");
      FILE_TYPE = "gif";
      const customImageCanvas = document.getElementById("customImageCanvas");
      const ctx = customImageCanvas.getContext("2d");
      ctx.font = "24px Arial";
      ctx.fillStyle = "#1da2d8";
      ctx.fillText("Loading...", 200, 200);

      const stage = new Konva.Stage({
        container: "tempContainer",
        width,
        height,
      });

      const layer = new Konva.Layer();
      stage.add(layer);

      const gif = new SuperGif({
        gif: image,
        progressbar_height: 0,
        auto_play: true,
        loop_mode: true,
        draw_while_loading: false,
      });

      gif.load(() => {
        ctx.clearRect(0, 0, 1000, 1000);
        resizeCustomImage(image.width, image.height);
        $("#gifHtmlInCanvas").remove();
        $(".canvas-container").append(
          `<div id="gifHtmlInCanvas"><img style="max-width:100%" src="${image.src}"></div>`,
        );
      });

      if (image.width > 600) {
        const scaleRatio = 600 / image.width;
        $("#customImageContainer")
          .css({
            transform: `scale(${scaleRatio})`,
            "transform-origin": "50px 50px",
          })
          .addClass("bigger-btns");
      }

      const getCanvas = gif.get_canvas();
      const canvas = getCanvas.cloneNode();
      const context = canvas.getContext("2d");

      const anim = () => {
        context.clearRect(0, 0, canvas.width, canvas.height);
        if (image.width > MAX_SIZE) {
          context.drawImage(
            getCanvas,
            0,
            0,
            MAX_SIZE,
            (MAX_SIZE * canvas.height) / canvas.width,
          );
        } else {
          context.drawImage(getCanvas, 0, 0);
        }
        layer.draw();
        requestAnimationFrame(anim);
      };
      anim();

      const layerImage = new Konva.Image({ image: canvas });
      layer.add(layerImage);

      $(".konvajs-content canvas")[0].setAttribute("id", "gifCanvas");
      $("#gifCanvas").prependTo(".canvas-container");
      $("#tempContainer").hide();
      $("#customImageUploadModal").modal("hide");
      $("#customImageModalTitle").text("Customize GIF");
      $("#customImageModal").modal("show");

      if (existingImage) $("#insertCustomImageBtn").text("Update Image");
      FABRIC_CANVAS.loadFromJSON(existingImage, () => {
        FABRIC_CANVAS.setBackgroundImage(
          null,
          FABRIC_CANVAS.renderAll.bind(FABRIC_CANVAS),
        );
      });
    } else {
      FILE_TYPE = "image";
      const displayEditor = () => {
        $("#customImageUploadModal").modal("hide");
        $("#customImageModalTitle").text("Customize Image");
        $("#customImageModal").modal("show");
        $(".canvas-container").addClass("image-center");
      };
      if (existingImage) {
        $("#insertCustomImageBtn").text("Update Image");
        FABRIC_CANVAS.loadFromJSON(existingImage, () => {
          FABRIC_CANVAS.renderAll();
          displayEditor();
        });
      } else {
        fabric.Image.fromURL(image.src, (img) => {
          FABRIC_CANVAS.setBackgroundImage(
            img,
            FABRIC_CANVAS.requestRenderAll.bind(FABRIC_CANVAS),
          );
          displayEditor();
        });
      }
      resizeCustomImage(width, height);
      FABRIC_CANVAS.setViewportTransform([1, 0, 0, 1, 0, 0]);
      FABRIC_CANVAS.requestRenderAll();
      const widthRatio = image.width > 600 ? 600 / image.width : 1;
      const heightRatio = image.height > 580 ? 580 / image.height : 1;
      FABRIC_CANVAS.setZoom(Math.min(widthRatio, heightRatio));
    }
  };
};
